import { Component, Watch, Vue } from 'vue-property-decorator'

@Component
class onLocaleChangeMixin extends Vue {

  protected fetches: Function[] = [];
  protected initFetches: Function[] = this.fetches;
  protected reFetches: Function[] = [];

  get language(): string {
    return this.$i18n.locale;
  }

  @Watch('language', {
    immediate: true
  })
  onLanguageChanged() {
    this.fetches.forEach((fetching: Function) => {
      fetching();
    })
  }

  @Watch('language')
  onLanguageChangedUpdate() {
    this.reFetches.forEach((fetching: Function) => {
      fetching();
    })
  }

  mounted(): void {
    this.initFetches.forEach((fetching: Function) => {
      fetching();
    })
  }

}

export default onLocaleChangeMixin
